// Curated navigation-emoji allowlist (PRIME-NAV-UX-002, locked decision 4).
//
// The personal-menu editor lets a user tag a SECTION or SUBMENU (never a page —
// page icons stay canonical, AC-06) with a small, friendly emoji. To keep the
// showcase safe and on-brand we do NOT accept arbitrary emoji input: the picker
// offers only the frozen set below, and any persisted value outside it is
// dropped to null on client load-normalize (navPreferences.normalizeSchema).
//
// The catalog is intentionally a CLIENT concern. The server stays a structural
// guard (it rejects markup/URL/whitespace-capable strings, decision 4) rather
// than mirroring this list, so curating the set never requires an API change.
//
// Every value here is a single, short emoji (≤ 8 UTF-16 units) with no ASCII
// markup/URL/whitespace characters, so a curated pick can never trip the server
// hardening — navEmojiCatalog.test.js proves that invariant.

// Themed rows drive the picker layout. The union (in order) IS the flat catalog.
export const NAV_EMOJI_ROWS = Object.freeze([
  {
    label: 'Status',
    emoji: Object.freeze(['🔥', '✅', '⚠️', '⭐', '🚩', '⏳', '🎯', '📌']),
  },
  {
    label: 'Fun',
    emoji: Object.freeze(['🎉', '🚀', '💡', '🧠', '👀', '🌟', '🏆', '🎨']),
  },
  {
    label: 'Work',
    emoji: Object.freeze(['📁', '📂', '📊', '📈', '📋', '🗂️', '🗓️', '🧰']),
  },
  {
    label: 'Mission',
    emoji: Object.freeze(['🛡️', '⚓', '🧭', '🔭', '📡', '🚁', '⚙️', '🔧']),
  },
  {
    label: 'Ops',
    emoji: Object.freeze(['💰', '💳', '📉', '🏷️', '🔒', '🔑', '📦', '🔔']),
  },
  {
    label: 'More',
    emoji: Object.freeze(['🌐', '📣', '🤝', '🧩', '⚡', '❤️', '🩺', '🏥']),
  },
]);

// Flat, ordered catalog (frozen) — the single source of truth for validation.
export const NAV_EMOJI_CATALOG = Object.freeze(NAV_EMOJI_ROWS.flatMap((row) => [...row.emoji]));

const CATALOG_SET = new Set(NAV_EMOJI_CATALOG);

/** True only for a value that is exactly one of the curated emoji. */
export function isCuratedEmoji(value) {
  return typeof value === 'string' && value.length > 0 && CATALOG_SET.has(value);
}

/** Curated value passes through; anything else (incl. non-strings) → null. */
export function normalizeCuratedEmoji(value) {
  return isCuratedEmoji(value) ? value : null;
}
